import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'
import _ from 'lodash'
import moment from 'moment'

const RewardDetailModal = (props) => {

    const { data, handleClose, show } = props
    
    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => handleClose()}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Modal.Header className='px-0'>
                <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                    Reward Detail
                </Modal.Title>
                <button className="modal-close-btn me-4 text-center" onClick={handleClose}>
                    <ImCross color='#fff' size={12} />
                </button>
            </Modal.Header>
            <Modal.Body className='px-4 justify-content-center'>
                <Row className='mb-3'>
                    <Col md={4}>
                        <div className='modal-small-heading'>Name</div>
                        <div className="modal-detail-value">{data?.name}</div>
                    </Col>
                    <Col md={4}>
                        <div className='modal-small-heading'>Allowed Redeems</div>
                        <div className="modal-detail-value">{data?.noOfAllowRedeems}</div>
                    </Col>
                    <Col md={4}>
                        <div className='modal-small-heading'>Redeem Count</div>
                        <div className="modal-detail-value">{data?.redeemedCount}</div>
                    </Col>
                    <Col md={4} className="mt-4">
                        <div className='modal-small-heading'>Required Points</div>
                        <div className="modal-detail-value">{data?.requiredPoints}</div>
                    </Col>
                    <Col md={4} className="mt-4">
                        <div className='modal-small-heading'>Status</div>
                        <div className="modal-detail-value">{data?.status ? _.startCase(_.camelCase(data?.status)) : ""}</div>
                    </Col>

                    <Col md={4} className="mt-4">
                        <div className='modal-small-heading'>Validity</div>
                        <div className="modal-detail-value">{data?.validity ? moment(data?.validity).format("Do-MMM-YYYY, h:mm a") : ""}</div>
                    </Col>

                    <Col md={12} className="mt-4">
                        <div className='modal-small-heading'>Description</div>
                        <div className="modal-detail-value">{data?.description}</div>
                    </Col>
                </Row>

            </Modal.Body>
        </Modal>
    )
}

export default RewardDetailModal